import React, { useState } from "react";
import apiRoutes from "../../../api/apiRoutes";
import { appFetchJson } from "../../../utils/http";

export default function EliminarPrecioProductoEessFuturo({
  registro = {},
  onClose = () => {},
  onDeleted = () => {},
}) {
  const [loading, setLoading] = useState(false);
  // Eliminamos el estado 'error' porque ya tienes un popup externo que lo maneja.

  const handleDelete = async () => {
    setLoading(true);

    try {
      const id = registro.id;
      if (!id) throw new Error("ID del registro no encontrado.");

      const url = apiRoutes.precioProductoEessFuturo.delete(id);
      
      // Hacemos la petición DELETE
      await appFetchJson(url, { method: "DELETE" });

      // Si todo sale bien:
      onDeleted();
      onClose();

    } catch (e) {
      console.error("Error al eliminar:", e);
      // No seteamos setError() porque el sistema global mostrará el Warning.
      
      // Si tu sistema de "Warning" depende de que el error burbujee (se propague),
      // descomenta la siguiente línea:
      // throw e; 
      
    } finally {
      setLoading(false);
    }
  };

  return (
    // Usamos .modal-backdrop de tu components.css
    <div className="modal-backdrop">
      
      {/* Usamos max-w-2xl para mantener el ancho igual a EliminarProducto */}
      <div className="bg-white w-full max-w-2xl rounded-lg shadow-xl overflow-hidden transform transition-all relative">
        
        {/* Header */}
        <div className="modal-header">
          <h2 className="section-title mb-0">Eliminar Precio Futuro</h2>
        </div>

        {/* Body */}
        <div className="modal-body">
          <div className="mb-4 px-4 py-3 text-sm text-blue-600 bg-blue-50 rounded border border-blue-100">
            ¿Está seguro que desea eliminar este precio futuro?
          </div>

          {/* Detalles del registro */}
          <div className="bg-gray-50 px-6 py-6 mb-2 space-y-2 rounded border border-gray-100">
            <div>
              <span className="text-gray-500 mr-1">EESS:</span>
              <span className="font-medium">{registro.eessNombre || registro.eess?.nombre || "—"}</span>
            </div>

            <div>
              <span className="text-gray-500 mr-1">Producto:</span>
              <span className="font-medium">{registro.productoNombre || registro.producto?.nombre || "—"}</span>
            </div>

            <div>
              <span className="text-gray-500 mr-1">Precio:</span>
              <span className="font-medium">
                {registro.precio ? Number(registro.precio).toLocaleString('es-PY') : "—"}
              </span>
            </div>

            <div>
              <span className="text-gray-500 mr-1">Vigencia:</span>
              <span className="font-medium">
                 {registro.fechaVigenciaIni ? registro.fechaVigenciaIni.split('T')[0] : "—"}
              </span>
            </div>

            <div>
              <span className="text-gray-500 mr-1">Estado:</span>
              <span className={`font-medium ${registro.estadoDescripcion?.includes('ACTIVO') ? 'text-green-600' : 'text-gray-700'}`}>
                 {registro.estadoDescripcion || registro.estadoNombre || "—"}
              </span>
            </div>
          </div>
          
        </div>

        {/* Footer */}
        <div className="modal-footer flex gap-2">
          <button className="btn-fil" onClick={handleDelete} disabled={loading}>
            {loading ? "Eliminando…" : "Eliminar"}
          </button>

          <button 
            className="btn-fil bg-gray-500 hover:bg-gray-600" 
            onClick={onClose}
          >
            Cancelar
          </button>
        </div>

      </div>
    </div>
  );
}